import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function EngagementIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 30, 30);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M11.6088 16.5018C12.3599 15.5242 13.3797 14.9233 14.503 14.9233C15.6263 14.9233 16.6461 15.5242 17.3972 16.5018M20.3972 19.2939C21.1484 18.3162 22.1682 17.7153 23.2914 17.7153C24.4147 17.7153 25.4345 18.3162 26.1857 19.2939M2.82031 19.2939C3.57146 18.3162 4.59126 17.7153 5.71454 17.7153C6.83781 17.7153 7.85762 18.3162 8.60876 19.2939M16.2395 11.5688C16.2395 12.5496 15.462 13.3447 14.503 13.3447C13.5439 13.3447 12.7665 12.5496 12.7665 11.5688C12.7665 10.5881 13.5439 9.79297 14.503 9.79297C15.462 9.79297 16.2395 10.5881 16.2395 11.5688ZM25.028 14.3609C25.028 15.3417 24.2505 16.1368 23.2914 16.1368C22.3324 16.1368 21.5549 15.3417 21.5549 14.3609C21.5549 13.3801 22.3324 12.585 23.2914 12.585C24.2505 12.585 25.028 13.3801 25.028 14.3609ZM7.45107 14.3609C7.45107 15.3417 6.6736 16.1368 5.71454 16.1368C4.75548 16.1368 3.978 15.3417 3.978 14.3609C3.978 13.3801 4.75548 12.585 5.71454 12.585C6.6736 12.585 7.45107 13.3801 7.45107 14.3609Z"
        stroke="#F5F5F5"
        strokeOpacity={0.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6088 16.5018C12.3599 15.5242 13.3797 14.9233 14.503 14.9233C15.6263 14.9233 16.6461 15.5242 17.3972 16.5018M20.3972 19.2939C21.1484 18.3162 22.1682 17.7153 23.2914 17.7153C24.4147 17.7153 25.4345 18.3162 26.1857 19.2939M2.82031 19.2939C3.57146 18.3162 4.59126 17.7153 5.71454 17.7153C6.83781 17.7153 7.85762 18.3162 8.60876 19.2939M16.2395 11.5688C16.2395 12.5496 15.462 13.3447 14.503 13.3447C13.5439 13.3447 12.7665 12.5496 12.7665 11.5688C12.7665 10.5881 13.5439 9.79297 14.503 9.79297C15.462 9.79297 16.2395 10.5881 16.2395 11.5688ZM25.028 14.3609C25.028 15.3417 24.2505 16.1368 23.2914 16.1368C22.3324 16.1368 21.5549 15.3417 21.5549 14.3609C21.5549 13.3801 22.3324 12.585 23.2914 12.585C24.2505 12.585 25.028 13.3801 25.028 14.3609ZM7.45107 14.3609C7.45107 15.3417 6.6736 16.1368 5.71454 16.1368C4.75548 16.1368 3.978 15.3417 3.978 14.3609C3.978 13.3801 4.75548 12.585 5.71454 12.585C6.6736 12.585 7.45107 13.3801 7.45107 14.3609Z"
        stroke="url(#paint0_linear_6469_552956)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6088 16.5018C12.3599 15.5242 13.3797 14.9233 14.503 14.9233C15.6263 14.9233 16.6461 15.5242 17.3972 16.5018M20.3972 19.2939C21.1484 18.3162 22.1682 17.7153 23.2914 17.7153C24.4147 17.7153 25.4345 18.3162 26.1857 19.2939M2.82031 19.2939C3.57146 18.3162 4.59126 17.7153 5.71454 17.7153C6.83781 17.7153 7.85762 18.3162 8.60876 19.2939M16.2395 11.5688C16.2395 12.5496 15.462 13.3447 14.503 13.3447C13.5439 13.3447 12.7665 12.5496 12.7665 11.5688C12.7665 10.5881 13.5439 9.79297 14.503 9.79297C15.462 9.79297 16.2395 10.5881 16.2395 11.5688ZM25.028 14.3609C25.028 15.3417 24.2505 16.1368 23.2914 16.1368C22.3324 16.1368 21.5549 15.3417 21.5549 14.3609C21.5549 13.3801 22.3324 12.585 23.2914 12.585C24.2505 12.585 25.028 13.3801 25.028 14.3609ZM7.45107 14.3609C7.45107 15.3417 6.6736 16.1368 5.71454 16.1368C4.75548 16.1368 3.978 15.3417 3.978 14.3609C3.978 13.3801 4.75548 12.585 5.71454 12.585C6.6736 12.585 7.45107 13.3801 7.45107 14.3609Z"
        stroke="#0059FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.833 9.05548C28.5242 12.8418 28.4336 17.3509 26.1911 21.2118C22.4655 27.6263 14.2109 29.8222 7.75405 26.1166L7.06633 25.7219M2.16698 19.9481C0.475811 16.1617 0.56644 11.6526 2.80888 7.7918C6.53454 1.37731 14.7891 -0.818678 21.246 2.88693L21.9337 3.28161M7 27.5L6.45842 25.19L8.5 24.5M20.2888 4.50157L22.5424 3.81311L21.9337 1"
        stroke="#F5F5F5"
        strokeOpacity={0.5}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.833 9.05548C28.5242 12.8418 28.4336 17.3509 26.1911 21.2118C22.4655 27.6263 14.2109 29.8222 7.75405 26.1166L7.06633 25.7219M2.16698 19.9481C0.475811 16.1617 0.56644 11.6526 2.80888 7.7918C6.53454 1.37731 14.7891 -0.818678 21.246 2.88693L21.9337 3.28161M7 27.5L6.45842 25.19L8.5 24.5M20.2888 4.50157L22.5424 3.81311L21.9337 1"
        stroke="url(#paint1_linear_6469_552956)"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.833 9.05548C28.5242 12.8418 28.4336 17.3509 26.1911 21.2118C22.4655 27.6263 14.2109 29.8222 7.75405 26.1166L7.06633 25.7219M2.16698 19.9481C0.475811 16.1617 0.56644 11.6526 2.80888 7.7918C6.53454 1.37731 14.7891 -0.818678 21.246 2.88693L21.9337 3.28161M7 27.5L6.45842 25.19L8.5 24.5M20.2888 4.50157L22.5424 3.81311L21.9337 1"
        stroke="#0059FF"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6469_552956"
          x1={28}
          y1={29.5}
          x2={-2.09161}
          y2={29.0426}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B20BFF" />
          <stop offset={1} stopColor="#0059FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6469_552956"
          x1={28}
          y1={29.5}
          x2={-2.09161}
          y2={29.0426}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B20BFF" />
          <stop offset={1} stopColor="#0059FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default EngagementIcon;
